;(function () {
  'use strict'

  angular.module('admin.winners.service', []).factory('WinnersService', WinnersService)

  /** @ngInject */
  function WinnersService($http, $q, API) {
    function buildParams(start, limit, filters) {
      var params = {}
      if (start !== undefined) params.start = start
      if (limit !== undefined) params.limit = limit

      if (filters) {
        if (filters.startDate) params.start_date = filters.startDate
        if (filters.endDate) params.end_date = filters.endDate
        if (filters.channels && filters.channels.length > 0) {
          params.channel_id = filters.channels
            .map(function (c) {
              return c.id || c
            })
            .join(',')
        }
        if (filters.userId) params.user_id = filters.userId
        if (filters.qId) params.q_id = filters.qId
        if (filters.status !== undefined && filters.status !== 'all') {
          params.status = filters.status
        }
      }
      return params
    }

    function list(start, limit, filters) {
      var defered = $q.defer()
      var params = buildParams(start, limit, filters)

      $http
        .get(API.API_URL + 'admin/winners', { params: params })
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function removeWinner(id, reason) {
      var defered = $q.defer()
      var payload = {}
      if (reason) payload.reason = reason

      $http
        .patch(API.API_URL + 'admin/winners/' + id, payload)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function getChannels() {
      var defered = $q.defer()
      $http
        .get(API.API_URL + 'channels')
        .success(function (res) {
          defered.resolve(res.results || res)
        })
        .error(defered.reject)
      return defered.promise
    }

    function getCollectibles() {
      var defered = $q.defer()
      $http
        .get(API.API_URL + 'collectibles/redeemable')
        .success(function (res) {
          defered.resolve(res.results || res)
        })
        .error(defered.reject)
      return defered.promise
    }

    return {
      list: list,
      removeWinner: removeWinner,
      getChannels: getChannels,
      getCollectibles: getCollectibles,
    }
  }
})()
